import Head from 'next/head';
import { useRouter } from 'next/router';
import { useAppStore } from 'src/hooks/useAppStore';

import {
  CountryCode,
  DisplayLanguage
} from 'src/utils/constants/stringConstants';
import { INDIA_LANGUAGES_LIST } from 'src/utils/constants/utilConstants';
import { getURL } from 'src/utils/OGTags';

type SEOMetaForLatestPropType = {
  title: string;
  description: string;
};

const SEOMetaForLatest = ({ title, description }: SEOMetaForLatestPropType) => {
  const { usersPreferenceData, usersLocationData } = useAppStore();
  const router = useRouter();
  const pathName = router.asPath;
  const { ENGLISH } = DisplayLanguage;
  const { IN } = CountryCode;

  const displayLanguage = usersPreferenceData?.display_language || ENGLISH;
  const countryCode = usersLocationData?.country_code || IN;
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description || ''} />
      <meta name="robots" content="noindex, nofollow" />
      <link
        rel="alternate"
        hrefLang="x-default"
        href={getURL(countryCode, ENGLISH, pathName)}
      />
      {countryCode === IN
        ? INDIA_LANGUAGES_LIST.map((lang) => {
            return (
              <link
                rel="alternate"
                key={lang}
                hrefLang={lang}
                href={getURL(countryCode, lang, pathName)}
              />
            );
          })
        : ''}
      {countryCode !== IN && displayLanguage !== ENGLISH ? (
        <link
          rel="alternate"
          hrefLang={`${displayLanguage}-${countryCode.toLowerCase()}`}
          href={getURL(countryCode, displayLanguage, pathName)}
        />
      ) : (
        ''
      )}
      {countryCode !== IN ? (
        <link
          rel="alternate"
          hrefLang={`${ENGLISH}-${countryCode.toLowerCase()}`}
          href={getURL(countryCode, ENGLISH, pathName)}
        />
      ) : (
        ''
      )}
    </Head>
  );
};

export default SEOMetaForLatest;
